<template>
	<div>
		<layout-1
			:table_name="'Vessel History'"
			:id=pageid
			:searchbar=true
			:navbar=false
			:button_perm="'56'"
			:button_name="'Select'"
			:term=term
			:reroute="'/0311'"
			:select_reroute=true
			:use_limit="false"
			:hide_first_column="true"
			style="width:100%; height:calc(100vh - 50px);"
		></layout-1>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.VESSEL_HISTORY_PAGE,
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Vessel_History.vue